export default __webpack_public_path__ + "2ceb366ee1dfaeeafa4d5f4ff8dbbde5.svg";